import styled from "styled-components";
import { TextField } from "@material-ui/core";
import { Heading } from "pages/customers/styles";
import { HeaderDiv as BaseHeaderDiv, LeftDiv as BaseLeftDiv } from "pages/location/styles";

export const CallCentreContainer = styled.div`
  padding: 1.5rem 2rem;
`;

export const HeaderDiv = styled(BaseHeaderDiv)`
  display: flex;
  justify-content: space-between;
`;

export const LeftDiv = styled(BaseLeftDiv)`
  display: flex;
  justify-content: space-between;
`;

export const HeadingDiv = styled(Heading)`
  margin-bottom: 0;
`;

export const CardDiv = styled.div`
  margin-top: 1rem;
  background: #ffffff;
  border-radius: 10px;
  min-height: 70vh;
  padding: 2rem 2.5rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const FieldContainer = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
`;

export const BtnFieldContainer = styled.div`
  margin-top: 2rem;
  margin-bottom: 1.5rem;
  display: flex;
  gap: 1rem;
`;

export const InputTextField = styled(TextField)`
  width: 40%;
  @media (max-width: 960px) {
    width: 70%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const Required = styled.span`
  color: red;
  margin-left: 2px;
`;
